/**
 * The bot's public identity on the web side. The backend owns the token;
 * the pages only need the username to build t.me links (the follow deep
 * link, the "open the bot" button). Overridable per environment so a
 * staging bot can be wired without a code change.
 */
export const TELEGRAM_BOT_USERNAME =
  process.env.NEXT_PUBLIC_TELEGRAM_BOT_USERNAME || "menzil_ai_bot";

export function telegramBotHref(): string {
  return `https://t.me/${TELEGRAM_BOT_USERNAME}`;
}

/** The residence follow for a browser that cannot push: Telegram opens
 *  on the bot with `/start follow_<cluster_id>` prefilled; one tap on
 *  Start and the bot binds the follow to that chat. No account. */
export function telegramFollowHref(clusterId: string): string {
  return `${telegramBotHref()}?start=follow_${encodeURIComponent(clusterId)}`;
}

/** The listing watch for a browser that cannot push: the bot gets
 *  `/start watch_<slug>` (the listing page's own slug, "bina-6464244")
 *  and writes to that chat when the price changes. No account. */
export function telegramWatchHref(slug: string): string {
  return `${telegramBotHref()}?start=watch_${encodeURIComponent(slug)}`;
}
